import { ApiEndpointKey, BdAppConfigRequest } from '@bindoc-projects/app-config-domain-lib';

export const ANALYTICS_P21_APP_CONFIG_REQUEST: BdAppConfigRequest = {
  id: 'analyticsP21App',
  hostKey: 'ANALYTICS_P21_APP_URL',
  domain: 'BINDOC',
  apiEndpointKeys: [
    ApiEndpointKey.AYS_VIRTUAL_CLINIC_RESOURCE_URL,
    ApiEndpointKey.AYS_VIRTUAL_CLINIC_P21_IMPORT_RESOURCE_URL,
    ApiEndpointKey.BD_FILES_RESOURCE_URL,
    ApiEndpointKey.BD_JOBS_RESOURCE_URL,
    ApiEndpointKey.BD_PERMISSION_RESOURCE_URL,
  ],
  unprotectedApiEndpointKeys: [
    ApiEndpointKey.BD_DISTRICT_URL,
  ],
  hostedApiEndpointKeys: [
    ApiEndpointKey.AYS_VIRTUAL_CLINIC_RESOURCE_URL,
    ApiEndpointKey.BD_FILES_RESOURCE_URL,
    ApiEndpointKey.BD_JOBS_RESOURCE_URL,
    ApiEndpointKey.BD_PERMISSION_RESOURCE_URL,
    ApiEndpointKey.BD_DISTRICT_URL,
  ],
  variableKeys: [
    'AYS_VIRTUAL_CLINIC_P21_IMPORT_APP',
    'AUTHENTICATION_AUTHORITY',
    'AUTHENTICATION_PASSWORD_RESET_AUTHORITY',
    'AUTHENTICATION_CLIENT_ID',
    'BD_DASH0_ENDPOINT_URL',
    'BD_DASH0_AUTH_TOKEN',
    'BD_DASH0_DATASET',
    'BD_DASH0_SERVICE_NAME',
    'BD_PRIMEUI_LICENSE',
    'BD_STAGING_BANNER',
    'COOKIE_MANAGER_DOMAIN_ID',
  ],
};
